import React from 'react';
import ModalConfirmacao from '~/Components/ModalConfirmacao';

// W-0651 — Modal de confirmação (HARD GATE antes de executar a operação destrutiva).
// Reusa o componente compartilhado ~/Components/ModalConfirmacao com um preview da operação
// (código antigo -> novo, GE/apelido, justificativa). PRD §4.4.
const ModalConfirmacaoAlteracao = ({
  show,
  onClose,
  codigoAntigo,
  codigoNovo,
  geLabel,
  apelidoConta,
  observacao,
}) => {
  const preview = [
    `Conta: ${codigoAntigo} → ${codigoNovo}`,
    apelidoConta ? `Apelido: ${apelidoConta}` : null,
    geLabel ? `GE: ${geLabel}` : null,
    observacao ? `Justificativa: ${observacao}` : null,
    '',
    'Esta operação é IRREVERSÍVEL. A conta antiga será excluída e todas as referências passarão a apontar para o novo código.',
  ]
    .filter((l) => l !== null)
    .join('\n');

  return (
    <ModalConfirmacao
      show={show}
      onClose={onClose}
      title="Confirma alteração de código?"
      message={preview}
      variant="danger"
      labelCancel="Cancelar"
      labelConfirm="Confirmar"
    />
  );
};

export default ModalConfirmacaoAlteracao;
